import vest, { test, enforce } from 'vest';
import { toForm } from './deal-form-adapter';
import any from 'vest/any';
import { DealEntity, DealStatus, AssociatedPerson } from '@lib/deals';
import { Pint } from '@api/pint';
import { uniq } from 'lodash';
type DealForm = ReturnType<typeof toForm>;

const requiredText = enforce.template(enforce.isString().isTruthy());

export const dealValidationSuite = vest.create((deal: Partial<DealForm> = {}) => {
  //console.log("dealValidationSuite deal:", deal);
  test('deal_buyers_empty', 'One of the deal buyers is empty', () => {
    enforce(
      (deal.buyers as Array<Partial<DealEntity>>).filter(x => x).every(x => x.name !== '') ||
        (deal.buyers as Array<Partial<DealEntity>>).filter(x => x).length == 1
    ).isTruthy();
  });

  test('associated_person_has_vtr_id', 'One of the associated person is empty', () => {
    if (deal.associated_person && deal.associated_person.length > 0) {
      enforce(
        (deal.associated_person).every(x => x.vtr_id !== '')
      ).isBoolean().isTruthy();
    }
  });
test(
  "associated_person_has_designation",
  "Role in Deal is mandatory for all associated persons",
  () => {
    if (deal?.associated_person?.length > 0) {
      const validPersons = deal.associated_person.filter(Boolean);

      enforce(
        validPersons.every(person => {
          const designation =
            person?.designation ||
            person?.meta?.selectedCompany?.designation;

          return designation && designation.trim() !== "";
        })
      )
        .isBoolean()
        .isTruthy();
    }
  }
);
  test('associated_person_empty', 'Found Duplicate Associated person', () => {
    if(deal.associated_person && ((deal.associated_person as Array<Partial<AssociatedPerson>>).filter(x => x).every(x => x.name !== '') ||
    (deal.associated_person as Array<Partial<AssociatedPerson>>).filter(x => x).length == 1)){
      const associated_person_name = (deal.associated_person as Array<Partial<AssociatedPerson>>)
        .filter(x => x)
        .map(x => (x.vtr_id ? x.vtr_id : (x.name || '').toLowerCase()))
        .filter(x => x !== '');
        enforce(uniq(associated_person_name).length == associated_person_name.length).isTruthy();
    }
  });

  test('deal_sellers_empty', 'One of the deal sellers is empty', () => {
    enforce(
      (deal.sellers as Array<Partial<DealEntity>>).filter(x => x).every(x => x.name !== '') ||
        (deal.sellers as Array<Partial<DealEntity>>).filter(x => x).length == 1
    ).isTruthy();
  });

  test('deal_contents_empty', 'One of the deal contents is empty', () => {
    enforce(
      (deal.contents as Array<Partial<DealEntity>>)
        .filter(x => x)
        .filter(x => (x['deleted'] ? !x['deleted'] : true))
        .every(
          x =>
            (x.name && x.name !== '') ||
            (x.book_name && x.book_name !== '') ||
            (x.working_title && x.working_title !== '')
        ) ||
        (deal.contents as Array<Partial<DealEntity>>)
          .filter(x => x)
          .filter(x => (x['deleted'] ? !x['deleted'] : true)).length == 1
    ).isTruthy();
  });

  test('deal_buyer', 'Buyer is required.', () => {
    enforce(deal.buyers.some(x => !!x.name)).isTruthy();
  });

  test('deal_entitities_duplicate', 'One or more deal entities are duplicate', () => {
    if (
      ((deal.buyers as Array<Partial<DealEntity>>).filter(x => x).every(x => x.name !== '') ||
        (deal.buyers as Array<Partial<DealEntity>>).filter(x => x).length == 1) &&
      ((deal.sellers as Array<Partial<DealEntity>>).filter(x => x).every(x => x.name !== '') ||
        (deal.sellers as Array<Partial<DealEntity>>).filter(x => x).length == 1) ||
      ((deal.to_air_on as Array<Partial<DealEntity>>).filter(x => x).every(x => x.name !== '') ||
        (deal.to_air_on as Array<Partial<DealEntity>>).filter(x => x).length == 1)
      // && (deal.contents as Array<Partial<DealEntity>>).every(x => typeof x !== 'undefined')
    ) {
      const deal_buyers_names = (deal.buyers as Array<Partial<DealEntity>>)
        .filter(x => x)
        .map(x => (x.vtr_id ? x.vtr_id : (x.name || '').toLowerCase()))
        .filter(x => x !== '');
      const deal_sellers_names = (deal.sellers as Array<Partial<DealEntity>>)
        .filter(x => x)
        .map(x => (x.vtr_id ? x.vtr_id : (x.name || '').toLowerCase()))
        .filter(x => x !== '');
     
      let deal_to_air_on_names = []
      if(deal?.to_air_on != undefined){
        deal_to_air_on_names = (deal.to_air_on as Array<Partial<DealEntity>>)
          .filter(x => x)
          .map(x => (x.vtr_id ? x.vtr_id : (x.name || '').toLowerCase()))
          .filter(x => x !== '');
      }
      // console.log(deal_to_air_on_names, "deal_to_air_on_names")
      // const deal_contents_names = (deal.contents as Array<Partial<DealEntity>>)
      //   .map(x => (x.vtr_id ? x.vtr_id : (x.name || '').toLowerCase()))
      //   .filter(x => x !== '');
      const all_deal_entities = [
        ...deal_buyers_names,
        ...deal_sellers_names,
        ...deal_to_air_on_names,
        // ...deal_contents_names,
      ];
      enforce(uniq(all_deal_entities).length == all_deal_entities.length).isTruthy();
    }
  });

  test('deal_contents_duplicate', 'One or more deal contents are duplicate', () => {
    if (
      (deal.contents as Array<Partial<DealEntity>>)
        .filter(x => x)
        .filter(x => (x['deleted'] ? !x['deleted'] : true))
        .every(
          x =>
            (x.name && x.name !== '') ||
            (x.book_name && x.book_name !== '') ||
            (x.working_title && x.working_title !== '')
        ) ||
      (deal.contents as Array<Partial<DealEntity>>)
        .filter(x => x)
        .filter(x => (x['deleted'] ? !x['deleted'] : true)).length == 1
    ) {
      
      const deal_contents_names = (deal.contents as Array<Partial<DealEntity>>)
        .filter(x => (x['deleted'] ? !x['deleted'] : true))
        .filter(x => x['vtr_id'])
        .map(x => x.vtr_id)
        .filter(x => x !== '');
      const deal_contents_working_titles = (deal.contents as Array<Partial<DealEntity>>)
        .filter(x => (x['deleted'] ? !x['deleted'] : true))
        .map(x => (x.working_title || '').toLowerCase())
        .filter(x => x !== '');
      const deal_contents_book_names = (deal.contents as Array<Partial<DealEntity>>)
        .filter(x => (x['deleted'] ? !x['deleted'] : true))
        .map(x => (x.book_name || '').toLowerCase())
        .filter(x => x !== '');
      const all_content_entities = [
        ...deal_contents_names,
        ...deal_contents_working_titles,
        ...deal_contents_book_names,
      ];
      enforce(uniq(all_content_entities).length == all_content_entities.length).isTruthy();
    }
  });


  

  test(
    'deal_included_excluded_country_same',
    'Same country in included and excluded country',
    () => {
      if (deal.included_country.length && deal.excluded_country.length) {
        const intersection = deal.included_country
          .map(x => x.id)
          .filter(element => deal.excluded_country.map(x => x.id).includes(element));
        enforce(intersection.length === 0).isTruthy();
      }
    }
  );

  test('deal_included_excluded_region_same', 'Same region in included and excluded region', () => {
    if (deal.included_region.length && deal.excluded_region.length) {
      const intersection = deal.included_region
        .map(x => x.id)
        .filter(element => deal.excluded_region.map(x => x.id).includes(element));
      enforce(intersection.length === 0).isTruthy();
    }
  });

  test(
    'deal_tags_exlusive_non_exlusive',
    'Exclusive and Non Exclusive tags cannot be present in tags',
    () => {
      if (deal.tags.length) {
        const hasBothExclusiveAndNonExlusive = deal.tags
          .map(x => x.name)
          .filter(x => x == 'Exclusive' || x == 'Non-Exclusive');
        enforce(hasBothExclusiveAndNonExlusive.length < 2).isTruthy();
      }
    }
  );

  // test('relation', 'Relation Type is required.', () => {
  //   enforce(deal.relation).isTruthy();
  // });

  test('published_date', 'Deal Date is required.', () => {
    // console.log({"newstate validator":deal})
    enforce(deal.published_date).isTruthy();
  });

  test(
    'deal_seller_or_content',
    'Either a Seller or a Content is required.',
    () =>
      any(
        () => enforce(deal.sellers.some(x => !!x.name)).isTruthy(),
        () =>
          enforce(
            (deal.contents as Array<Partial<DealEntity>>)
              .filter(x => (x['deleted'] ? !x['deleted'] : true))
              .some(x => !!x.name || !!x.book_name || !!x.working_title)
          ).isTruthy()
      ) as any
  );

  // if (deal.content) {
  //   const content: Pint.Content = deal?.content?.meta;
  //   if (content && content?.content_type?.toLowerCase() === 'movie') {
  //     test('content', 'Season should be empty if content is Movie Series', () => {
  //       enforce(deal.deal_season).isEmpty();
  //     });
  //   }
  // }

  test('sentences', 'At least 1 deal source is required.', () => {
    enforce(deal.sentences).isNotEmpty();
  });

  test('deal_type', 'Deal Type is required.', () => {
    requiredText(deal.deal_type);
  });

  // test('deal_Associated', 'Associated person is required.', () => {
  //   requiredText(deal.deal_type);
  // });

  test('deal_badge', 'Deal Badge is required.', () => {
    requiredText(deal.deal_badge.name);
  });
  test('deal_subtype', 'Deal Subtype is required.', () => {
    // console.log({"subtype"})
    // requiredText(deal.deal_subtype);
    enforce(deal.deal_subtype.length).greaterThan(0)
  });
  

  if (deal.status === DealStatus.skipped) {
    test('comment', 'Comment is required before marking a deal as skipped.', () => {
      enforce(deal.comment.filter(x => x.new).length).greaterThan(0);
    });
  }
  // test('deal_badge', 'Deal Badge is required.', () => {
  //   requiredText(deal.deal_badge.name);
  // });

  if (deal.deal_status == 'Cancelled' || deal.deal_status == 'Expired') {
    test(
      'deal_expiry_date',
      'Deal Status Expiry Date is required for creating cancelled/expired deals.',
      () => {
        enforce(deal.deal_expiry_date).isTruthy();
      }
    );
  }
  // test(
  //   'deal_expiry_date',
  //   'Same country in included and excluded country',
  //   () => {
  //     if (deal.deal_status != 'Active') {
  //       enforce(deal.buyers.some(x => !!x.name)).isTruthy();
  //     }
  //   }
  // );
});

function isNumber(str) {
  return /^-?\d+(\.\d+)?$/.test(str);
}

const SEASON_RENEWAL = "Season Renewal";
export const dialogContentValidationSuite = vest.create((dialogData = {}) => {
  test(
    'deal_content_title',
    'Please enter a content name or a working title or a book name',
    () => {
      const contentTitle =
        (dialogData.dialogContent && dialogData.dialogContent.name) ||
        dialogData.book_name ||
        dialogData.working_title;
      requiredText(contentTitle);
    }
  );
  if(dialogData?.deal_season && dialogData?.dialogContent?.deal_subtype?.some((subtype)=> subtype?.name === SEASON_RENEWAL)){
    test(
      'deal_season',
      'Please enter a valid Deal Season.',
      () => {
        const isValidDealSeason = isNumber(dialogData?.deal_season);
        enforce(isValidDealSeason).isTruthy();
      }
    );
  }

});

export const dialogAssociatedPersonValidationSuite = vest.create((dialogData = {}) => {
  test('deal_associated_person', 'Please select the associated person', () => {
    const associatedPerson = dialogData.associated_person.name;

    requiredText(associatedPerson);
  });
});



